import type { GQLError } from '../../resources';

export enum LifecycleState {
  Complete = 'Complete', // BE filters out for now, but FE is ready to handle
  Replaced = 'Replaced', // BE filters out for now, not handled by FE
  Rejected = 'Rejected',
  Scheduled = 'Scheduled',
  AppliedToPurchase = 'AppliedToPurchase',
  Expired = 'Expired',
  Active = 'Active',
  NeedsManualAppraisal = 'NeedsManualAppraisal',
  DeclinedReprice = 'DeclinedReprice' // BE filters out for now, but FE is ready to handle
}

export type VehicleSummary = {
  acquisitionName: string;
  appraisalId: string;
  color?: string;
  daysToExpiration?: number;
  expirationDate: string;
  // legacy support
  isDrivable?: boolean;
  isOfferAccepted: boolean;
  lifecycleState: LifecycleState;
  make?: string;
  model?: string;
  trim?: string;
  // legacy support
  vehicleImages?: {
    mobileImage?: string;
  };
  vehicleValue: number;
  year?: number;
};

export type VehicleSummariesData = {
  vehicleSummaries: VehicleSummary[];
};

export type VehicleSummariesResponse = {
  data: VehicleSummariesData;
  errors?: GQLError[];
};

const getVehicleSummariesQuery = `
  query getVehicleSummaries {
	vehicleSummaries {
		acquisitionName
		appraisalId
		color
    daysToExpiration
		expirationDate
		isOfferAccepted
		lifecycleState
		make
		model
		trim
		vehicleValue
		year
	}
}`;

export default getVehicleSummariesQuery;
